/**
 * D-201: the DIGU Classic front of house (Welcome, Sign in): the lime club mark, DIGU over a tracked-out CLASSIC and the
 * brand sheet's lime sweep along the bottom. Brand colours, so it looks the same in every theme.
 */
import type { ReactElement } from "react";
import { BrandMark } from "./Header";
import { Icon } from "./Icon";

export function BrandHero(): ReactElement {
  return (
    <div className="signin__hero" role="img" aria-label="DIGU Classic">
      <BrandMark size={84} />
      <span className="lockup-word signin__word" aria-hidden="true">DIGU</span>
      <span className="lockup-sub signin__classic" aria-hidden="true">CLASSIC</span>
      <svg className="signin__sweep" viewBox="0 0 400 90" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 62C110 20 250 104 400 30V90H0z" />
        <path className="signin__sweep-line" d="M0 74C120 34 245 112 400 46" />
      </svg>
    </div>
  );
}

/** The brand sheet's four attributes, as what you get: four players, skill, rankings, occasions. */
const ATTRIBUTES: { icon: string; label: string }[] = [
  { icon: "players", label: "Four players at a table" },
  { icon: "zap", label: "Skill and strategy" },
  { icon: "trophy", label: "Rankings and leaderboards" },
  { icon: "star", label: "Special events" },
];
export function BrandAttributes(): ReactElement {
  return (
    <ul className="brand-attrs" aria-label="What DIGU Classic has">
      {ATTRIBUTES.map((a) => <li key={a.icon} className="brand-attrs__item"><Icon name={a.icon} size={22} /><span>{a.label}</span></li>)}
    </ul>
  );
}
